<div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
    <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
        <h2 class="noMarginHeader">
            <mat-icon>bar_chart</mat-icon> Reports
        </h2><br />
    </div>
</div>

<ul>
    <li>
        <a [routerLink]="['/vouchers/reports/nitrate-exceedance']" title="Nitrate Exceedance Indicator Missing Report">Nitrate Exceedance Indicator Missing Report</a>
    </li> 
    <li>
        <a [routerLink]="['/vouchers/reports/exceedance-not-indicated']" title="Vouchers with exceedance in samples but not Flagged Report">Vouchers with exceedance in samples but not Flagged Report</a>
    </li>
    <li>
        <a [routerLink]="['/vouchers/reports/missing-lat-long']" title="Wells with Vouchers missing Lat/Long Report">Wells with Vouchers missing Lat/Long Report</a>
    </li>
    <li>
        <a [routerLink]="['/household/reports/missing-lat-long']" title="Households missing Lat/Long Report">Households &amp; Housing Units missing Lat/Long Report</a>
    </li>
    <li>
        <a [routerLink]="['/household/reports/multiple-housing-units']" title="Households with Multiple Housing Units Report">Households with Multiple Housing Units Report</a>
    </li>
    <li>
        <a href="{{env.powerbiLink}}" title="Tableau Reports" target="_blank">BI Reports</a> 
    </li>

</ul>